<template>
  <v-list-item
    draggable="true"
    @dragstart.prevent="dragStart"
    two-line
    class="pl-0 elevation-1 white mb-2"
    @click=""
    @mouseup="openContext"
    dense
  >
    <v-list-item-avatar tile class="ma-1 ml-0">
      <c-icon icon="context" :color="iconColor" size="22"></c-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>
        <span class="subtitle-1">{{ context.text }}</span>
      </v-list-item-title>
      <v-list-item-subtitle>
        {{ context.latestState ? context.latestState : 'Just created context' }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-icon>more_vert</v-icon>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  props: { context: {}, iconColor: { default: 'grey' } },
  computed: {
    ...mapGetters('components/dragdrop', ['dragging'])
  },
  methods: {
    ...mapMutations('components/dragdrop', ['setDragPosition', 'updateDraggedData']),
    openContext() {
      if (!this.dragging) {
        this.$router.push({ name: 'context', params: { contextId: this.context.id } });
      }
    },
    dragStart(event) {
      // get the element and shift positions for dragHelper
      const element = this.$el;
      console.log(element);
      const html = element.outerHTML;
      const ids = [this.context.id];
      //  Build the html drag element
      // ids.forEach(i => {
      //   html += this.$refs[i][0].$el.innerHTML;
      // });
      //const element = this.$refs[id][0].$el.innerHTML;
      // update drag data
      const dragObject = {
        element,
        shift: {
          x: event.clientX - element.getBoundingClientRect().left,
          y: event.clientY - element.getBoundingClientRect().top
        },
        html,
        ids,
        types: ['statusContext'],
        parent: { type: this.context.userStatus }
      };
      //  first set initial drag position
      const { x, y } = event;
      this.setDragPosition({ x, y });

      //  now set drag content
      this.updateDraggedData(dragObject);

      // //  setup move listeners
      // document.addEventListener('mousemove', this.updateDragPos);
      // document.addEventListener('mouseup', this.handleDragStop);
    }
  }
};
</script>

<style></style>
